import CommonHelper from 'helpers/CommonHelper';
import styled from 'styled-components';

import e_logo from '../../../../assets/E_Logo.svg';
import stripeHasSubsImg from '../../../../assets/stripeHasSubs.webp';
import stripeWithoutSubsImg from '../../../../assets/stripeWithoutSubsImg.webp';

const getImageUrlByExpireSubDate = (isExpireLessWeekSub: boolean, isExpiredSub: boolean): string => {
  if (isExpiredSub) {
    return stripeWithoutSubsImg;
  }
  if (isExpireLessWeekSub) {
    return stripeHasSubsImg;
  }
  return '';
};

interface IImageModalSectionProps {
  isExpireLessWeekSub: boolean;
  isExpiredSub: boolean;
}

interface IRootProps {
  url: string;
  children?: React.ReactNode;
}

const ImageModalSection: React.FC<IImageModalSectionProps> = (props) => {
  const { isExpireLessWeekSub, isExpiredSub } = props;
  const imageUrl = getImageUrlByExpireSubDate(isExpireLessWeekSub, isExpiredSub);

  return (
    <Root url={imageUrl} >
      <Logo />
    </Root >
  );
};

export default ImageModalSection;

const Root = styled.div<IRootProps>`
  width: 45%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-image: ${({ url }) => `url(${CommonHelper.getEroplayCdnUrl(url)})`};
  position: relative;
  background-size: 100% 100%;
  border-radius: 12px 0 0 12px;
  `;

const Logo = styled.div`
  background-image: url(${CommonHelper.getEroplayCdnUrl(e_logo)});
  background-size: contain;
  background-repeat: no-repeat;
  width: 60%;
  height: 38px;
  position: absolute;
  bottom: 8%;
  left: 50%;
  transform: translateX(-25%);
  `;
